<template>
  <button :class="classes" @click="emit('click', $event)" @focus="emit('focus', $event)" :disabled="disabled">
    <slot>Button</slot>
  </button>
</template>

<script setup lang="ts">
import { ButtonVariants } from "@medapro-types/common/common";
import { computed } from "vue";

const emit = defineEmits(["click", "focus", "mouseenter"]);

const props = withDefaults(
  defineProps<{
    /**
     * Variation of Button Color in 'Corporate Style'
     */
    variant?: ButtonVariants;
    /**
     * This are the in the Styleguide defined styles.
     */
    designStyle?: "mono" | "quiet" | "muted" | "select";
    /**
     * Set to true if the Button Contains Icons and Text
     */
    withIcon?: boolean;
    /**
     * Set to true if the Button Contains ONLY an Icon
     */
    onlyIcon?: boolean;
    disabled?: boolean;
  }>(),
  {
    variant: "secondary",
    withIcon: false,
    onlyIcon: false
  }
);

const classes = computed(() => {
  const defaultClasses = ["btn"];
  const variantClasses = [`btn-${props.variant}`];
  const conditionalClasses = { "btn-with-icon": props.withIcon, "btn-icon": props.onlyIcon, disabled: props.disabled };

  return [...defaultClasses, ...variantClasses, props.designStyle, conditionalClasses];
});
</script>
